import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import SocketService from './socket.js';

// Available screen types
const availableScreens = [
  {
    id: 'impact-machine',
    name: 'Impact Machine',
    icon: '⚡',
    description: 'Strategic planning with consequences',
    route: '/impact-machine'
  },
  {
    id: 'impact-path',
    name: 'Impact Path',
    icon: '🛤️',
    description: 'Visualize pathways to impact',
    route: '/impact-path'
  },
  {
    id: 'individual-impact-path',
    name: 'Individual Builder',
    icon: '👤',
    description: 'Build your personal impact pathway',
    route: '/individual-impact-path'
  },
  {
    id: 'data',
    name: 'Data Visualization',
    icon: '📊',
    description: 'Display charts and statistics',
    route: '/screen/data'
  },
  {
    id: 'painpoints',
    name: 'Kipupisteäänestys',
    description: 'The room votes on the pre-work pain-point groups',
    route: '/kipupisteet'
  },
  {
    id: 'solutions',
    name: 'Solutions Explorer',
    icon: '💡',
    description: 'Explore proposed solutions',
    route: '/screen/solutions'
  },
  {
    id: 'futures',
    name: 'Future Scenarios',
    icon: '🔮',
    description: 'Visualize potential futures',
    route: '/screen/futures'
  },
  {
    id: 'table',
    name: '3D Table View',
    icon: '🎲',
    description: 'Interactive 3D central display',
    route: '/table'
  }
];

export function useScreenNavigation(options = {}) {
  const { disabled = false, screenMode = false } = options;
  const navigate = useNavigate();

  useEffect(() => {
    // Skip navigation when in screen mode (managed by ScreenClient) or explicitly disabled
    if (disabled || screenMode) {
      return;
    }

    const socket = SocketService.socket;
    if (!socket) return;

    const handleScreenCommand = (command) => {
      console.log('📺 useScreenNavigation received command:', command);

      // Handle navigation commands
      if (command.command === 'switch-view' && command.payload.view) {
        console.log('📺 useScreenNavigation switching to view:', command.payload.view);
        const screen = availableScreens.find(s =>
          s.route === command.payload.view ||
          s.route.includes(command.payload.view.toLowerCase())
        );
        if (screen) {
          console.log('📺 useScreenNavigation navigating to:', screen.route);
          navigate(screen.route);
        } else {
          console.warn('📺 useScreenNavigation unknown screen route:', command.payload.view);
        }
      }
    };

    // Remove any existing listeners first to prevent duplicates
    socket.off('screen-command', handleScreenCommand);
    socket.on('screen-command', handleScreenCommand);

    return () => {
      socket.off('screen-command', handleScreenCommand);
    };
  }, [navigate, disabled, screenMode]);
}

export { availableScreens };